import React from 'react'
import { Tooltip, Typography } from '@mui/material'
import { GridFilterInputValueProps } from '@mui/x-data-grid-pro'
import { useProfessionsMinimalQuery } from '@typings/graphql'
import { getFilterOperatorSelect } from '@shared/dataGrid/filter/getFilterOperatorSelect'
import { FilterSelectInput } from '@shared/dataGrid/filter/FilterSelectInput'
import { UserColumnType, UsersRowModel } from '@features/users/provider/UsersProvider'

const RenderedFilter: React.FC<GridFilterInputValueProps> = (props) => {
  const { data } = useProfessionsMinimalQuery()

  const selectItems = React.useMemo(() => {
    if (!data) {
      return []
    }

    return data.professions.map((profession) => ({
      id: profession.id,
      name: profession.texts.title,
      key: profession.id
    }))
  }, [data])

  return (
    <FilterSelectInput
      items={selectItems}
      {...props}
    />
  )
}

const RenderCell: React.FC<{row: UsersRowModel}> = ({ row }) => {
  const titles = React.useMemo(() => {
    return row?.profession?.texts?.title || '-'
  }, [row])

  return <Tooltip title={titles}>
    <Typography
      variant="subtitle1"
      fontWeight={500}
    >
      {titles }
    </Typography>
  </Tooltip>
}

export const professionColumnModel: UserColumnType = {
  field: 'professionId',
  width: 150,
  filterOperators: getFilterOperatorSelect(RenderedFilter),
  sortable: false,
  valueGetter: ({ row }) => (row as UsersRowModel)?.profession?.id || '',
  renderCell: (params) => (<RenderCell row={params.row as UsersRowModel} />)
}
